import React from 'react';

import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';

import timeFromNow from '@src/services/timeFromNow';

import StatusLabels from '@src/components/global/titles/StatusLabels';
import LoadingElement from '@src/components/loader';

class AlertsMenuItem extends React.PureComponent {
    static propTypes = {
        displayName: PropTypes.string,
        uncheckedCount: PropTypes.shape({
            // eslint-disable-next-line camelcase
            unchecked_count: PropTypes.number,
        }),
        alertsData: PropTypes.shape({
            loaded: PropTypes.string.isRequired,
            alerts: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.number.isRequired,
                slug: PropTypes.string.isRequired,
                title: PropTypes.string,
                // eslint-disable-next-line camelcase
                read_by_user: PropTypes.bool,
                // eslint-disable-next-line camelcase
                updated_at: PropTypes.string,
            })),
        }),
        onFocus: PropTypes.func.isRequired,
    };

    handleFocus = (e) => {
        if (e) {
            e.preventDefault();
        }

        if (this.props.onFocus) {
            this.props.onFocus();
        }
    };

    renderAlerts = () => {
        const { alertsData } = this.props;

        if (!alertsData || alertsData.loaded !== 'complete') {
            return <LoadingElement style={{ transform: 'scale(0.5)' }} />;
        }

        return alertsData.alerts.map((alert) => (
            <Dropdown.Item
                key={`alert-${alert.id}`}
                className={alert.read_by_user ? '' : 'unread'}
                as={Link}
                to={`/alerts/${alert.slug}`}
            >
                <span className="alert-item-title">
                    <StatusLabels expiredAt={alert.expired_at} archivedAt={alert.archived_at} />
                    {alert.title}
                </span>
                <span className="alert-item-time">{timeFromNow(alert.updated_at)}</span>
            </Dropdown.Item>
        ));
    };

    render() {
        const { displayName, uncheckedCount } = this.props;

        const alertCount = uncheckedCount ? uncheckedCount.unchecked_count : 0;
        const alertClassName = alertCount > 0 ? 'has-alerts' : '';
        const badgeClasses = alertCount > 0 ? 'unchecked-count has-alerts' : 'unchecked-count';

        return (
            <Dropdown
                as={Nav.Item}
                title={displayName}
                id="nav-dropdown-alerts"
                className="nav-item"
                tabIndex={-1}
            >
                <Dropdown.Toggle
                    as={Nav.Link}
                    className={alertClassName}
                    tabIndex={1000}
                    role="link"
                    onFocus={this.handleFocus}
                >
                    <span className="alerts-title">Alerts</span>
                    <span className="alerts-icon" />
                    <span className={badgeClasses}>{alertCount}</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    { this.renderAlerts() }
                    <Dropdown.Item as={Link} to="/alerts" className="view-all-link">
                        View All
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

export default AlertsMenuItem;
